// export const BaseIp = "http://192.168.29.113:8087/"; // Local Server

export const BaseIp = "https://lesdigitallibrary.in/"; // Web Server 

export const ProIp = BaseIp + "digital-library/";  // Local Server with AppName /digital-library/userLoginAPI